<template>
  <div class="modal" v-if="visible">
    <transition name="modal">
      <div :class="[backDrop ?'modal-backdrop': '', 'modal-mask']" @click="$emit('hide')">
        <div class="container">
          <div v-if="close && backDrop" class="close-btn" @click="$emit('hide')">
            <img src="/assets/new/ic_popup_close.png" />
          </div>
          <div class="modal-wrapper">
            <div :class="['modal-container',
                          wrapShadow?'modal-shadow':'',
                          modalContentClass,
                          isFull ? 'modal-container-full' : isSmall ? 'modal-container-sm' : 'modal-container-md']"
                 @click="ignoreHide($event)"
                 style="border-radius:10px">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    backDrop:{
      type: Boolean,
      default: true
    },
    close:{
      type: Boolean,
      default: true
    },
    wrapShadow:{
      type: Boolean,
      default: true
    },
    isSmall : {
      type: Boolean,
      default: false
    },
    isFull: {
      type:Boolean,
      default: false,
    },
    modalContentClass:{
      type: String,
      default: ''
    }
  },
  methods: {
    ignoreHide(event) {
      event.stopPropagation()
    }
  },
  watch:{
    visible(){
      if(this.visible)
        this.$emit('onShow');
      else
        this.$emit('onHide');
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: table;
  width: 100%;
  height: 100%;
}
.close-btn {
  position: absolute;
  right: 30px;
  top:50px;
  width: 20px;
  height: 20px;
  z-index: 1000;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
  display: table;
  transition: opacity .3s ease;
}

.modal-backdrop{
  background-color: rgba(0, 0, 0, 0.32);
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  background-color: transparent;
  border-radius: 10px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;

}
.modal-container-md {
  margin: 0 20px;
}
.modal-container-full {
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}
.modal-container-sm {
  margin: auto;
  width: fit-content;
}

.modal-shadow{
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.mo-content{
  width: 100%;
}
</style>